var React = require('react');

function MinusSquare (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-32 252a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-56a12 12 0 0 1 12-12h264a12 12 0 0 1 12 12z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M368 228v56a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-56a12 12 0 0 1 12-12h264a12 12 0 0 1 12 12z","className":"fa-primary","key":2})]);
}

MinusSquare.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = MinusSquare;

MinusSquare.default = MinusSquare;
